import { Component, Input, OnInit} from '@angular/core';
import { AlertService, IAlertType } from '../../../../_shared/services';
import { InvoicesStoreService } from "../../../../_shared/services";
import { Invoices, StatusButtons } from '../../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import {CurrencyPipe, DatePipe, NgIf} from "@angular/common";
import {
  checkCircleIcon,
  ClarityIcons,
  exclamationCircleIcon,
  exclamationTriangleIcon,
  infoCircleIcon
} from "@cds/core/icon";

import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-job-details-invoices',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    ClrIconModule,
    DatePipe,
    NgIf,
    CurrencyPipe
  ],
  templateUrl: './job-details-invoices.component.html',
  styleUrl: './job-details-invoices.component.sass'
})

export class JobDetailsInvoicesComponent implements OnInit {
  invoices: Invoices[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusLabel = 'alert-info';
  statusText = '';

  @Input() projectID: string = '';
  @Input() jobID: number = 0;

  constructor(
    private invss: InvoicesStoreService,
    private alertDispatcher: AlertService
  ) {
    ClarityIcons.addIcons(infoCircleIcon, checkCircleIcon, exclamationCircleIcon, exclamationTriangleIcon)
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadList();
  }

  statusButtons: StatusButtons[] = [
    { state: 'draft', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'open', display: 'Offen', label: 'alert-info', icon: 'info-circle'},
    { state: 'partially', display: 'Teilbezahlt', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'overdue', display: 'Fällig', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'paid', display: 'Bezahlt', label: 'alert-success', icon: 'check-circle'},
    { state: 'cancelled', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'}
  ];

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(invoicestatus: string) {
    const statusline = this.findButtonStatus(invoicestatus, this.statusButtons);
    return statusline >= 0 ? this.statusButtons[statusline].label : 'alert-info';
  }

  loadList() {
    this.invss.getInvoices(0, 0, this.projectID, this.jobID, 0,'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Invoices gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.invoices = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    })
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus) + " alert-sm";
  }
}
